// disabeld元素
export function disabledElement(el: HTMLElement): void {
	Object.assign(el.style, {
		opacity: '0.6',
		'pointer-events': 'none',
		cursor: 'not-allowed',
	});
	el.setAttribute('disabled', 'disabled');
}

export function abledElement(el: HTMLElement): void {
	Object.assign(el.style, {
		opacity: '1',
		cursor: 'initial',
		'pointer-events': 'initial',
	});
	el.removeAttribute('disabled');
}

// 隐藏元素
export function hideElement(el: HTMLElement | null): void {
	if (el) {
		el.style.display = 'none';
	}
}

export function showElement(el: HTMLElement | null): void {
	if (el) {
		el.style.display = 'block';
	}
}

// 移除元素
export function removeElement(el: HTMLElement): void {
	const parentNode = el.parentNode;
	if (parentNode) {
		parentNode.removeChild(el);
	}
}
